import { createFromIconfontCN } from '@ant-design/icons';

const IconFont = createFromIconfontCN({
  scriptUrl: 'https://at.alicdn.com/t/font_1794059_wia34skss5b.js',
});

export default IconFont;
